import { runTot } from "./payroll.js";
export const STATUTORY_SOURCES = [
  {
    agency: "SSS & EC",
    effective: "2025-01-01",
    detail:
      "15% total; 5% employee and 10% employer, MSC ₱5,000–₱35,000; employer-only EC ₱10 / ₱30.",
    url: "https://www.sss.gov.ph/pay-contribution/",
  },
  {
    agency: "PhilHealth",
    effective: "2024-01-01",
    detail:
      "5% of monthly basic salary; ₱10,000 floor and ₱100,000 ceiling, shared equally.",
    url: "https://www.philhealth.gov.ph/circulars/2020/circ2020-0005.pdf",
  },
  {
    agency: "Pag-IBIG",
    effective: "2024-02-01",
    detail:
      "Maximum fund salary ₱10,000; employee 1% up to ₱1,500, otherwise 2%; employer 2%.",
    url: "https://www.pagibigfund.gov.ph/document/pdf/payments/ESRS.pdf",
  },
  {
    agency: "BIR withholding",
    effective: "2023-01-01",
    detail:
      "RR 11-2018 Annex E semi-monthly table. Minimum-wage tax treatment is evaluated separately from statutory contributions.",
    url: "https://bir-cdn.bir.gov.ph/local/pdf/Annex%20E%20RR%2011-2018.pdf",
  },
  {
    agency: "13th-month pay",
    effective: "1975-12-16",
    detail:
      "Accrual of one-twelfth of basic earnings, including piece-rate production earnings; payment due by December 24.",
    url: "https://bwc.dole.gov.ph/dole-bwc-urges-employers-to-release-13th-month-pay-not-later-than-december-24/",
  },
  {
    agency: "Western Visayas wage floor",
    effective: "2025-11-19",
    detail:
      "RBVI-29: ₱550 daily for the encoded non-agriculture category with more than ten workers.",
    url: "https://nwpc.dole.gov.ph/region-vi/",
  },
  {
    agency: "Central Visayas Class A wage floor",
    effective: "2026-10-14",
    detail: "ROVII-27: ₱582 daily for Class A, including Naga City, Cebu.",
    url: "https://nwpc.dole.gov.ph/region-vii/",
  },
];
export function monthlyStatutory(s, month) {
  const runs = s.runs.filter(
      (r) => r.pay.startsWith(month) && r.status !== "DRAFT",
    ),
    totals = {
      sssEE: 0,
      sssER: 0,
      ec: 0,
      phEE: 0,
      phER: 0,
      hdEE: 0,
      hdER: 0,
      tax: 0,
      accrual13: 0,
    };
  for (const r of runs) {
    const t = runTot(r);
    for (const k in totals)
      totals[k] +=
        k === "accrual13"
          ? r.lines.reduce((a, l) => a + (l.accrual13 || 0), 0)
          : t[k] || 0;
  }
  return {
    runs,
    totals,
    agencies: [
      {
        agency: "SSS & EC",
        account: "2210",
        employee: totals.sssEE,
        employer: totals.sssER + totals.ec,
      },
      {
        agency: "PhilHealth",
        account: "2220",
        employee: totals.phEE,
        employer: totals.phER,
      },
      {
        agency: "Pag-IBIG",
        account: "2225",
        employee: totals.hdEE,
        employer: totals.hdER,
      },
      {
        agency: "BIR compensation tax",
        account: "2235",
        employee: totals.tax,
        employer: 0,
      },
    ],
  };
}
export function statutoryChecklist(s) {
  const employer = [
      "tin",
      "sssEmployer",
      "philhealthEmployer",
      "pagibigEmployer",
    ].filter((k) => !s.company[k]),
    employees = s.employees
      .map((e) => ({
        emp: e.id,
        missing: ["tin", "sss", "philhealth", "pagibig"].filter((k) => !e[k]),
      }))
      .filter((e) => e.missing.length);
  return { employer, employees };
}
